export default "__VITE_ASSET__48lba47r__"